import * as React from 'react';
import {LISTABLE_TYPES} from 'dicts/lists';
import BuildingResourceFigure from 'components/ResourceFigure/BuildingResourceFigure';
import ClientResourceFigure from 'components/ResourceFigure/ClientResourceFigure';
import LeadResourceFigure from 'components/ResourceFigure/LeadResourceFigure';
import ProjectResourceFigure from 'components/ResourceFigure/ProjectResourceFigure';

export default function ListItemIcon({itemType, hasProducts, hasOffers, className}) {
	if (itemType === LISTABLE_TYPES.buildings) {
		return (
			<BuildingResourceFigure
				hasProducts={hasProducts}
				hasOffers={hasOffers}
				className={className}
			/>
		);
	}

	if (itemType === LISTABLE_TYPES.clients) {
		return <ClientResourceFigure className={className} />;
	}

	if (itemType === LISTABLE_TYPES.leads) {
		return <LeadResourceFigure className={className} />;
	}

	if (itemType === LISTABLE_TYPES.projects) {
		return <ProjectResourceFigure className={className} />;
	}

	return null;
}
